import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select-bulgari',
  templateUrl: './select-bulgari.component.html',
  styleUrls: ['./select-bulgari.component.scss']
})
export class SelectBulgariComponent {
  @Input() showSelect = false;
  @Input() optionSelected: any;
  @Input() optionLabelProp!: string;
  @Input() optionValueProp!: string;
  @Input() selectOptions: any;

  @Output() handle_onAction = new EventEmitter();

  triggerAction(event: any) {
    this.handle_onAction.emit(event);
  }

}
